import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IDeleteDialogData {
  message: string;
}

@Component({
  selector: 'app-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss'],
  standalone: false
})
export class DeleteConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<DeleteConfirmDialogComponent>>(MatDialogRef);
  data = inject<IDeleteDialogData>(MAT_DIALOG_DATA);
}
